import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EzidebitMethodPage } from './ezidebit-method.page';

const routes: Routes = [
  {
    path: '',
    component: EzidebitMethodPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EzidebitMethodPageRoutingModule {}
